import * as React from 'react';

function SvgTooltipIcon(props) {
  return (
    <svg
      width={15}
      height={15}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 6.875a.625.625 0 00-.625.625V10a.625.625 0 101.25 0V7.5a.625.625 0 00-.625-.625zm.237-2.45a.625.625 0 00-.474 0 .625.625 0 00-.207.131c-.055.061-.1.13-.131.207a.625.625 0 00.131.681c.061.055.13.1.207.131a.625.625 0 00.68-1.019.625.625 0 00-.205-.131zM7.5 1.25a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 11.25a5 5 0 110-9.999 5 5 0 010 9.999z"
        fill="#0F8CFF"
      />
    </svg>
  );
}

export default SvgTooltipIcon;
